// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__3pJjC","colCheckbox":"styles_colCheckbox__3a0O8"};